<template>
  <div id="register" class="register mregister">
    <app-header head-title="注册"></app-header>
    <div class="registerPart">
      <app-tips></app-tips>
      <div class="banner">
        <div class="center">
          <div class="title-tips">
            <div class="title-line"></div>
          </div>
          <div class="registerDiv">
            <el-form
              ref="registForm"
              :model="registForm"
              :rules="registRules"
              class="register-form"
              autocomplete="on"
              label-position="left"
            >
              <el-form-item prop="mobile" class="phoneNumber" :class="{'active': blur01}" :error="mobileErrorMsg">
                <span class="mobile-icon"></span>
                <el-input
                  id="inputs1"
                  ref="mobile"
                  v-model.number="registForm.mobile"
                  placeholder="请输入手机号"
                  name="mobile"
                  autocomplete="off"
                  maxlength="11"
                  type="tel"
                  @focus="mobileErrorMsg=''"
                />
              </el-form-item>
              <div class="check-code-div">
                <el-form-item prop="code" class="check-code" :class="{'active': blur02}" ref="code" :error="codeErrorMsg">
                  <span class="code-icon"></span>
                  <el-input
                    id="inputs2"
                    @blur="blur2"
                    v-model.trim="registForm.code"
                    type="text"
                    maxlength="6"
                    placeholder="校验码"
                    name="code"
                  />
                </el-form-item>
                <img
                  ref="imgCode"
                  :src="varHost + 'uc/auth/register/captcha'"
                  @click="imgCodeRefresh()"
                  class="code-img"
                  alt="校验码"
                />
              </div>
              <el-form-item
                class="code"
                :class="{'active': blur03}"
                prop="mobile_verify_code"
                ref="mobile_verify_code"
                :error="phoneCodeErrorMsg"
              >
                <span class="mobile_verify_code-icon"></span>
                <el-input
                  id="inputs3"
                  @blur="blur3"
                  v-model.trim="registForm.mobile_verify_code"
                  placeholder="验证码"
                  name="mobile_verify_code"
                  maxlength="6"
                  type="tel"
                  @keyup.enter.native="handleRegist"
                  autocomplete="new-password"
                />
              </el-form-item>
              <el-button
                :class="{'is-timing':able}"
                class="codeBtn"
                :disabled="able"
                type="primary"
                @click="checkPhone()"
              >
                <span v-show="show">获取验证码</span>
                <span v-show="!show">{{count}} s</span>
              </el-button>
              <el-form-item prop="password" class="last" :class="{'active': blur04}">
                <span class="password-icon"></span>
                <el-input
                  id="inputs4"
                  @blur="blur4"
                  maxlength="16"
                  ref="password"
                  v-model.trim="registForm.password"
                  placeholder="请设置密码"
                  name="password"
                  :type="pwdSee?'text':'password'"
                  autocomplete="new-password"
                />
                <i class="input-icon" :class="{hidden:pwdSee}" @click="showPwd()"></i>
              </el-form-item>
              <div class="agreeMent">
                我已阅读并同意
                <i
                  class="icon"
                  :class="{iconActive:agreeMent}"
                  @click="agreeMent=!agreeMent"
                ></i>
                <span class="showDetails" @click="agreeFn()">《环球网用户服务条款与隐私保护政策》</span>
              </div>
              <el-button
                :loading="loading"
                class="registerBtn"
                type="primary"
                @click.native.prevent="handleRegist"
              >注册</el-button>

              <div class="backToLogin">
                已有账号，
                <span class="toLogin" @click="toLogin">点击登录</span>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<style scoped>
.register .el-button.codeBtn {
  float: right;
  height: 30px;
  font-size: 13px;
  margin-top: -37px;
  margin-right: 7.5px;
  z-index: 100;
  position: relative;
  padding: 0 12px;
  box-sizing: border-box;
  background-color: #4981f2;
  color: #fff;
  border-radius: 6px;
  width: auto;
}
</style>
<script>
import user from "@/api/user";
import header from "@/components/common/header";
import footer from "@/components/common/footer";
import tips from "@/components/common/tips";
import { androidFontFn } from "@/utils/androidFont";

export default {
  name: "Regist",
  components: {
    "app-header": header,
    "app-footer": footer,
    "app-tips": tips
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value.toString().length == 0) {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      var reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\S]{8,16}$/;
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else if (!reg.test(value)) {
        callback(new Error("密码需为8～16位大小字母、数字组合"));
      } else {
        callback();
      }
    };
    var validateCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入六位图形校验码"));
      } else {
        callback();
      }
    };
    const validatePhoneCode = (rule, value, callback) => {
      if (value.length != 6) {
        callback(new Error("请输入六位短信验证码"));
      } else {
        callback();
      }
    };
    return {
      registForm: {
        mobile: "",
        code: "",
        mobile_verify_code: "",
        password: ""
      },
      registRules: {
        mobile: [
          { required: true, trigger: "blur", validator: validatePhone },
          { type: "number", message: "手机号必须为数字值", trigger: "blur" }
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePass }
        ],
        mobile_verify_code: [
          { required: true, trigger: "blur", validator: validatePhoneCode }
        ],
        code: [{ required: true, trigger: "blur", validator: validateCode }]
      },
      loading: false,
      pwdSee: false,
      redirect: undefined,
      show: true,
      count: "",
      timer: null,
      able: false,
      agreeMent: false,
      mobileErrorMsg: "",
      codeErrorMsg: "",
      phoneCodeErrorMsg: "",
      hasGetCode: false,
      blur01: false,
      blur02: false,
      blur03: false,
      blur04: false,
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  computed: {},
  created() {
    // this.getCode()
    if (this.$route.params.registForm) {
      this.registForm = this.$route.params.registForm;
    }
  },
  mounted() {
    document.getElementById('register').addEventListener("mousedown", function(e){
      if(e.target['id'].indexOf('inputs') != 0){
        e.preventDefault()
      }
    }, false);
    androidFontFn();
  },
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#f3f2f0");
  },
  beforeDestroy() {
    // document.querySelector("body").removeAttribute("style");
  },
  methods: {
    // blur1(){
    //   this.blur01 = true
    // },
    blur2(){
      this.blur02 = true
      this.blur01 = false
      this.blur03 = false
      this.blur04 = false
    },
    blur3(){
      this.blur03 = true
      this.blur01 = false
      this.blur02 = false
      this.blur04 = false
    },
    blur4(){
      this.blur04 = true
      this.blur01 = false
      this.blur02 = false
      this.blur03 = false
    },
    agreeFn() {
      this.agreeMent=true
      this.$router.push({
        name: "agreement",
        params: { registForm: this.registForm }
      });
    },
    // mobileBlurFn() {
    //   this.blur01 = true
    //   this.blur02 = false
    //   this.blur03 = false
    //   this.blur04 = false
    //   this.$refs["registForm"].validateField("mobile", error => {
    //     if (error) {
    //       return false;
    //     } else {
    //       //校验手机号是否已注册
    //       user
    //         .registerPhoneCheck({ mobile: this.registForm.mobile })
    //         .then(result => {
    //           if (result.data.code == 1) {
    //             this.errorMsgEmpty();
    //             this.mobileErrorMsg = "账号已存在，请直接登录";
    //           }
    //         })
    //         .catch(error => {
    //           this.errorMsgEmpty();
    //           this.$nextTick(function() {
    //             typeof error == "string" ? (this.mobileErrorMsg = error) : true;
    //           });
    //         });
    //     }
    //   });
    // },
    checkForm(cb) {
      this.$refs["registForm"].validateField("mobile", error => {
        if (error) {
          return false;
        } else {
          this.$refs["registForm"].validateField("code", error => {
            if (error) {
              return false;
            } else {
              this.$refs["registForm"].validateField(
                "mobile_verify_code",
                error => {
                  if (error) {
                    return false;
                  } else {
                    this.$refs["registForm"].validateField(
                      "password",
                      error => {
                        if (error) {
                          return false;
                        } else {
                          cb();
                        }
                      }
                    );
                  }
                }
              );
            }
          });
        }
      });
    },
    checkPhone() {
      this.errorMsgEmpty();
      this.$refs["registForm"].validateField("mobile", error => {
        if (error) {
          return false;
        } else {
          this.$refs["registForm"].validateField("code", error => {
            if (error) {
              return false;
            } else {
              this.getCode();
            }
          });
        }
      });
    },
    getCode() {
      // 发送请求获取验证码
      this.errorMsgEmpty();
      user
        .getMsgRegist({
          mobile: this.registForm.mobile,
          captcha: this.registForm.code
        })
        .then(response => {
          this.lockGetCode();
          // this.hasGetCode = true;
        })
        .catch(error => {
          this.imgCodeRefresh();
          // this.hasGetCode = false;
          this.$nextTick(function() {
            if (typeof error == "string") {
              console.log(error);
              error == "手机号已存在，请直接用手机号登录"
                ? (this.mobileErrorMsg = error)
                : (this.codeErrorMsg = error);
            }
          });
          this.$refs["code"].resetField();
        });
      // this.imgCodeRefresh();
    },
    showPwd(which) {
      this.pwdSee = !this.pwdSee;
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    errorMsgEmpty() {
      this.mobileErrorMsg = "";
      this.codeErrorMsg = "";
      this.phoneCodeErrorMsg = "";
    },
    lockGetCode() {
      this.able = true;
      // 倒计时
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            this.able = false;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    toLogin() {
      this.$router.push({ path: "/mlogin" });
    },
    imgCodeRefresh() {
      this.$refs.imgCode.src =
        this.varHost + "uc/auth/register/captcha?" + Math.random();
    },
    handleRegist() {
      this.checkForm(this.registedFn);
      // this.checkForm();
    },
    registedFn() {
      if (!this.agreeMent) {
        if (document.getElementsByClassName("el-message").length === 0) {
          this.$Message.info("请阅读协议并确认后勾选");
        }
        return;
      }
      this.$refs.registForm.validate(valid => {
        if (valid) {
          this.errorMsgEmpty();
          //获取验证码校验手机号 后端校验
          // if (!this.hasGetCode) {
          //   user
          //     .getMsgRegist({
          //       mobile: this.registForm.mobile,
          //       captcha: this.registForm.code
          //     })
          //     .then(response => {
          //       // this.lockGetCode();
          //       // this.codeErrorMsg = "请输入短信验证码";
          //     })
          //     .catch(error => {
          //       this.imgCodeRefresh();
          //       this.$nextTick(function() {
          //         if (typeof error == "string") {
          //           console.log(error);
          //           error == "手机号已存在，请直接用手机号登录"
          //             ? (this.mobileErrorMsg = error)
          //             : (this.codeErrorMsg = error);
          //         }
          //       });
          //       // this.$refs["code"].resetField();
          //     });
          // } else {
            //处理注册
            this.loading = true;
            user
              .register(this.registForm)
              .then(response => {
                this.loading = false;
                if (response.data.redirect) {
                  return (location.href = response.data.redirect);
                } else {
                  return (location.href = "https://m.huanqiu.com");
                }
              })
              .catch(error => {
                this.loading = false;
                this.$nextTick(function() {
                  typeof error == "string"
                    ? (this.phoneCodeErrorMsg = error)
                    : true;
                });
                // this.$refs["mobile_verify_code"].resetField();
              });
          // }
        }
      });
    }
  }
};
</script>

<style lang="scss">
/* reset element-ui css */
html,
body {
  height: 100%;
  width: 100%;
}
.register {
  .el-input {
    display: inline-block;
    height: 42px;

    input {
      border: 0px;
      -webkit-appearance: none;
      border-radius: 6px;
      padding: 12px 5px 12px 15px;
      height: 42px;
    }
  }

  .el-form-item {
    background: #fff;
    border-radius: 6px;
    color: #454545;
    margin-bottom: 18px;
    .input-icon {
      width: 16px;
      height: 10px;
      background: url("../../assets/images/icons.png") no-repeat -78px -22px;
      display: inline-block;
      position: absolute;
      right: 15px;
      top: 16px;
      cursor: pointer;
    }
    .input-icon.hidden {
      background: url("../../assets/images/icons.png") no-repeat -105px -22px;
    }
    .el-form-item__content {
      line-height: 42px;
      height: 42px;
    }
  }

  .el-form-item.active .el-form-item__content .el-form-item__error{
    z-index: 1000;
    background: #f3f2f0;
    padding-bottom: 2px;
  }
  .el-form-item.code {
    width: 210px;
  }
  .el-form-item.last {
    margin-bottom: 12px;
  }
  .check-code-div {
    width: 210px;
    position: relative;
    .check-code {
      width: 210px;
      .el-input {
        width: 210px;
      }
    }
    .code-img {
      width: 100px;
      height: 36px;
      position: absolute;
      right: -110px;
      top: 1px;
    }
  }
}
.register.mregister{
  .el-form-item .el-input__inner{
    padding-top: 0!important;
    padding-bottom: 0!important;
    line-height: 43px!important;
  }
  input::-webkit-input-placeholder{
    font-size: 16px;
    line-height: 43px;
  }    
  input:-moz-placeholder{
    line-height: 43px;
    font-size: 16px;
  }                
  input::-moz-placeholder{
    line-height: 43px;
    font-size: 16px;
  }                  
  input:-ms-input-placeholder{
    line-height: 43px;
    font-size: 16px;
  }          
}
</style>

<style lang="scss" scoped>
.tips >>> .center {
  width: 100% !important;
  .tips-content {
    width: 100%;
    word-wrap: normal;
    font-size: 12px !important;
    color: #4c4c4c !important;
    line-height: 16px !important;
    font-weight: 300 !important;
  }
  .icon {
    display: none !important;
  }
}

.phoneNumber >>> .el-form-item__error {
  position: absolute;
  left: 0;
  top: 180px;
  width: 100%;
  background: #f5f5f5;
  text-align: left;
}

.check-code-div >>> .el-form-item__error {
  position: absolute;
  left: 0;
  top: 135px;
  width: 100%;
  background: #f5f5f5;
  text-align: left;
}

.code >>> .el-form-item__error {
  position: absolute;
  left: 0;
  top: 90px;
  width: 100%;
  background: #f5f5f5;
  text-align: left;
}

.last >>> .el-form-item__error {
  position: absolute;
  width: 100%;
  background: #f5f5f5;
  text-align: left;
}

#app {
  .headerOuter,
  .footer {
    display: none;
  }
  height: 100%;
  width: 100%;
  .tips {
    height: auto;
    padding: 12px 17.5px;
    box-sizing: border-box;
    top: 110px;
  }
}

.register {
  background: #f3f2f0 url(../../assets/images/mregister-bg.png) no-repeat top
    center;
  background-size: 100%;
  width: 100%;
  overflow: hidden;
  .mobile-icon,
  .password-icon,
  .mobile_verify_code-icon,
  .code-icon {
    position: absolute;
    left: 20px;
    top: 3px;
    width: 18px;
    height: 39px;
    z-index: 1;
    background: url("../../assets/images/mlogin1.png") no-repeat center;
    background-size: 100%;
  }
  .password-icon,
  .mobile_verify_code-icon,
  .code-icon {
    background: url("../../assets/images/mlogin2.png") no-repeat center;
    background-size: 100%;
  }
  .el-input {
    display: inline-block;
    height: 45px;
    >>> input {
      border: 0px;
      // border-bottom: 0 !important;
      border-radius: 6px 6px 0 0 !important;
      -webkit-appearance: none;
      border-radius: 6px;
      padding: 12px 5px 12px 54px;
      height: 45px;
    }
    >>> input[name="password"] {
      border-radius: 0 0 6px 6px !important;
      border-bottom: 1px solid #ccc !important;
    }
    >>> input[name="code"] {
      border-radius: 0 !important;
    }
    >>> input[name="mobile_verify_code"] {
      border-radius: 0 !important;
    }
  }

  >>> .el-form-item {
    border-radius: 6px;
    color: #454545;
    margin-bottom: 0;
    .input-icon {
      width: 16px;
      height: 10px;
      background: url("../../assets/images/icons.png") no-repeat -78px -22px;
      display: inline-block;
      position: absolute;
      right: 15px;
      top: 16px;
      cursor: pointer;
    }
    .input-icon.hidden {
      background: url("../../assets/images/icons.png") no-repeat -105px -22px;
    }
    .el-form-item__content {
      line-height: 45px;
      height: 45px;
    }
  }

  >>> .el-form-item.code {
    width: 100%;
  }

  .check-code-div {
    width: 100%;
    position: relative;
    .check-code {
      width: 100%;
      .el-input {
        width: 100%;
      }
    }
    .code-img {
      width: 100px;
      height: 36px;
      position: absolute;
      right: 7.5px;
      top: 4px;
    }
  }

  .el-form-item.is-error .el-input__inner {
    border: #f6343d solid 1px !important;
    color: #f6343d !important;
  }
  .registerPart {
    height: 100%;
    // background: url(../../assets/images/RegisterBG.png) repeat-x top;
    position: relative;
    .title-tips {
      position: absolute;
      top: 101px;
      left: 50%;
      z-index: 101;
      margin-left: -200px;
      width: 400px;
      height: 0px;
      background: url(../../assets/images/icons.png) no-repeat 0px -408px;
      background-size: 100%;
      .title-line {
        position: absolute;
        bottom: -9px;
        left: 50%;
        z-index: 101;
        margin-left: -50px;
        width: 100px;
        height: 3px;
        background: url(../../assets/images/icons.png) no-repeat -40px -240px;
      }
    }
    .center {
      height: 720px;
      position: relative;
      width: 100%;
      margin: 0 auto;
    }
    .registerDiv {
      width: 100%;
      margin: 0 auto;
    }
  }

  .register-form {
    position: relative;
    max-width: 100%;
    padding: 210px 30px 0;
    margin: 0 auto;
    overflow: hidden;
  }
  .registerBtn {
    width: 100%;
    height: 45px;
    margin-bottom: 12px;
    color: #fff;
    border-radius: 6px;
    background: #2b7ff7;
    box-shadow: inset 0px -8px 0px 0 #3f79ee, 0px 6px 0px 0 #e5e5e5;
    font-size: 21px;
  }
  .show-pwd {
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
  }
  .backToLogin {
    margin-top: 15px;
    font-size: 13px;
    text-align: center;
    .toLogin {
      color: #4981f2;
      cursor: pointer;
    }
  }
  .agreeMent {
    position: relative;
    margin-bottom: 30px;
    margin-top: 20px;
    height: 26px;
    padding-left: 22px;
    box-sizing: border-box;
    width: 100%;
    color: #595959;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 12px;
    line-height: 26px;
    letter-spacing: 0px;
    text-align: left;
    .showDetails {
      color: #4981f2;
      text-decoration: none;
    }
    .icon {
      cursor: pointer;
      width: 14px;
      height: 14px;
      position: absolute;
      left: 0px;
      top: 6px;
      background: url(../../assets/images/icons.png) no-repeat -50px -20px;
    }
    .iconActive {
      background: url(../../assets/images/icons.png) no-repeat -20px -20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mregister/index.vue